import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "loginScreen" }
const _hoisted_2 = { class: "col-md-10 offset-md-3 col-xs-8 offset-xs-2 col-lg-10 offset-lg-4" }
const _hoisted_3 = { class: "home" }
const _hoisted_4 = { class: "home-left" }
const _hoisted_5 = { class: "login-top" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "login" }
const _hoisted_8 = { class: "login-options" }
const _hoisted_9 = { class: "login-row" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "login-row mock-option"
}
const _hoisted_13 = { class: "mock-wrapper mtop-02" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "flex-col" }
const _hoisted_16 = {
  key: 1,
  class: "login-row mock-option"
}
const _hoisted_17 = { class: "mock-wrapper mtop-02" }
const _hoisted_18 = { class: "flex-col" }
const _hoisted_19 = { class: "login-bottom" }
const _hoisted_20 = { class: "help" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "help" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "welcome" }
const _hoisted_25 = { class: "welcome-top" }
const _hoisted_26 = { class: "welcome-bottom" }
const _hoisted_27 = ["src"]
const _hoisted_28 = ["src"]

import {onMounted, ref, watchEffect} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { authStore } from "@/stores/useAuthStore";
import { AuthErrorCode, AuthQueryParam, LoginOption, LoginType} from "@/models/auth.model";
import { AuthenticationApi } from "@/apiGenerate/authentication";
import { authenticationApiConfig } from "@/config/authentication-api.config";
import esButton from '@/components/esButton.vue';
import { toastError } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import { useI18n } from 'vue-i18n';
import SharedService from "@/services/SharedService";
import { usePermissionsStore } from '@/stores/permissionsStore';
import { Permissions } from "@/models/permissions.model";


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const MOCK_LT: boolean = process.env.VUE_APP_MOCK_LT;

const route = useRoute();
const router = useRouter();
const toast = useToast();
const permissionsStore = usePermissionsStore();
const { t } = useI18n();

const api = new AuthenticationApi(authenticationApiConfig);

const authorizationCode = ref<string | null>(null);
const formData = ref({ SAMLRequest: '' });

const auth = authStore();
const MOCK: boolean = process.env.VUE_APP_SHOW_MOCK_LOGIN === "true";
const EMERGENCY: boolean = process.env.VUE_APP_SHOW_EMERGENCY_LOGIN === "true";
const MAIL_CONTACT = process.env.VUE_APP_MAIL_CONTACT;


const loginOptions = ref<LoginOption[]>([
  { type: LoginType.VTSSW, imageSrc: require('@/assets/images/LT/mobile.png'), altText: 'Mobile login option' },
  { type: LoginType.SMARTCARD, imageSrc: require('@/assets/images/LT/smartcard.png'), altText: 'Smartcard login option' },  
  { type: LoginType.EMERGENCY, imageSrc: require('@/assets/images/LT/smartcard.png'), altText: 'BackUp Login' },  
]);

const SAMLRequestInput = ref<HTMLInputElement | null>(null);
const form = ref<HTMLFormElement | null>(null);
const dropd = ref("");
const dropd2 = ref("");
const inputValue = ref("");
const inputPASSWORDValue = ref("");

const loginLT = async (device: string) => {
  try {

    const response = await api.getAuthenticationSamlRequest({ tspId: device });

    if (response.samlRequest) {
      formData.value.SAMLRequest = response.samlRequest;

      if (SAMLRequestInput.value) {
        SAMLRequestInput.value.value = response.samlRequest;
      }

      form.value.action = response.url;
      form.value.submit();
    }

  } catch (error) {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t('error.USER_AUTHENTICATED_FAILED')
    });
  }
};

const loginByPass = async (device: string) => {
  try {

    if (device == LoginType.BYPASS) {
      const response = await api.getAuthenticationSamlRequest({ tspId: device + '-' + inputValue.value });
      router.push(response.url);
    }

  } catch (error) {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t('error.USER_AUTHENTICATED_FAILED')
    });
  }
};
const bakcuplogin = async (device: string) => {
  try {

    if (device == LoginType.EMERGENCY) {
      const response = await api.postEmergencyLogin({ ssn: inputValue.value, password : inputPASSWORDValue.value  });
      router.push(response.url);
    }

  } catch (error) {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t('error.USER_AUTHENTICATED_FAILED')
    });
  }
};


const exchangeCodeForToken = async () => {
  if (!authorizationCode.value) {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t('error.USER_AUTHENTICATED_FAILED')
    });
    return;
  }

  try {
    const response = await api.postAuthenticationToken({
      postAuthenticationToken: {
        grantType: AuthQueryParam.AUTHORIZATION_CODE,
        code: authorizationCode.value
      }
    });

    if (response.idToken && response.refreshToken) {
      auth.setTokens(response.idToken, response.refreshToken);

      const accessTask: boolean = await permissionsStore.checkPermission(Permissions.task.ACCESS_TASK.name);
      const accessAccounting: boolean = await permissionsStore.checkPermission(Permissions.accounting.ACCESS_ACCOUNTING.name);
      const accessCalendar:boolean = await permissionsStore.checkPermission(Permissions.planning.ACCESS_PLANNING.name);

      if (accessCalendar) {
        router.push("/calendar");
      } else if (accessTask) {
        router.push("/tasks");
      } else if (accessAccounting) {
        router.push("/accounting/income");
      } else {
        router.push("/error?error=USER_WITHOUT_AVAILABLE_MODULE");
      }
      
    }
  } catch (error) {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t('error.USER_AUTHENTICATED_FAILED')
    });
  }
};

watchEffect(() => {
  const code = route.query[AuthQueryParam.AUTHORIZATION_CODE];
  const error = route.query.error;

  if (code && !authorizationCode.value) {
    authorizationCode.value = code as string;
    exchangeCodeForToken();
  }

  if (error === AuthErrorCode.USER_NOT_FOUND) {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t('error.USER_AUTHENTICATED_FAILED')
    });
  }
});

const isToasterOpened = ref(false);
onMounted(() => {
  if (auth.toasterMessage) {
    isToasterOpened.value = true;
  }
});


return (_ctx: any,_cache: any) => {
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _unref(SharedService).getIcon('logos-fullname', false, 'login')
            }, null, 8, _hoisted_6),
            _cache[12] || (_cache[12] = _createElementVNode("hr", { class: "separator" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h3", null, _toDisplayString(_unref(t)('login.title')), 1),
            _createElementVNode("p", null, _toDisplayString(_unref(t)('login.subtitle')), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: "login-option w-full h-full",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (loginLT(_unref(LoginType).SMARTCARD)))
                }, [
                  _createElementVNode("img", {
                    src: _unref(SharedService).getIcon('luxtrust', false, 'login')
                  }, null, 8, _hoisted_10),
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('login.smartCard')), 1)
                ]),
                _createElementVNode("div", {
                  class: "login-option w-full h-full",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (loginLT(_unref(LoginType).VTSSW)))
                }, [
                  _createElementVNode("img", {
                    src: _unref(SharedService).getIcon('lux_trust_mobile', false, 'login')
                  }, null, 8, _hoisted_11),
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('login.mobile')), 1)
                ])
              ]),
              MOCK
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_dropdownBox, {
                        modelValue: dropd.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dropd).value = $event))
                      }, {
                        dropd: _withCtx(() => [
                          _createElementVNode("div", _hoisted_15, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              ref: "innerRef",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputValue).value = $event)),
                              autoFocus: true,
                              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (loginByPass(_unref(LoginType).BYPASS)), ["enter"]))
                            }, null, 544), [
                              [_vModelText, inputValue.value]
                            ]),
                            _createVNode(esButton, {
                              label: 'OK',
                              isPrimary: false,
                              disabled: false,
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (loginByPass(_unref(LoginType).BYPASS)))
                            })
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_buttonGroup, { class: "w-full h-full pad-s pleft-04" }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: require('@/assets/images/LT/mock.png'),
                                alt: 'Mock login option',
                                class: "login-image w-full h-full"
                              }, null, 8, _hoisted_14)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              EMERGENCY
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_dropdownBox, {
                        modelValue: dropd.value,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dropd).value = $event))
                      }, {
                        dropd: _withCtx(() => [
                          _createElementVNode("div", _hoisted_18, [
                            _cache[14] || (_cache[14] = _createElementVNode("span", null, "SSN", -1)),
                            _cache[15] || (_cache[15] = _createTextVNode()),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              ref: "ssn",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((inputValue).value = $event)),
                              autoFocus: true
                            }, null, 512), [
                              [_vModelText, inputValue.value]
                            ]),
                            _cache[16] || (_cache[16] = _createElementVNode("span", null, "Password", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "password",
                              ref: "password",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((inputPASSWORDValue).value = $event)),
                              onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (bakcuplogin(_unref(LoginType).EMERGENCY)), ["enter"]))
                            }, null, 544), [
                              [_vModelText, inputPASSWORDValue.value]
                            ]),
                            _createVNode(esButton, {
                              label: 'OK',
                              isPrimary: false,
                              disabled: false,
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (bakcuplogin(_unref(LoginType).EMERGENCY)))
                            })
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_buttonGroup, { class: "w-full h-full pad-s pleft-04" }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createElementVNode("p", null, "BACKUP LOGIN", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("form", {
                ref_key: "form",
                ref: form,
                method: "POST"
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.SAMLRequest) = $event)),
                  type: "hidden",
                  name: "SAMLRequest",
                  ref_key: "SAMLRequestInput",
                  ref: SAMLRequestInput
                }, null, 512), [
                  [_vModelText, formData.value.SAMLRequest]
                ])
              ], 512)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[17] || (_cache[17] = _createElementVNode("hr", { class: "separator" }, null, -1)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("p", null, _toDisplayString(_unref(t)('login.noAccount')), 1),
              _createElementVNode("a", {
                href: 'mailto:'+_unref(MAIL_CONTACT)
              }, _toDisplayString(_unref(t)('login.askToBeContacted')), 9, _hoisted_21)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("p", null, _toDisplayString(_unref(t)('login.needHelp')), 1),
              _createElementVNode("a", {
                href: 'mailto:'+ _unref(MAIL_CONTACT)
              }, _toDisplayString(_unref(t)('login.contactUs')), 9, _hoisted_23)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("h1", null, _toDisplayString(_unref(t)('login.welcome')), 1),
            _createElementVNode("h4", null, _toDisplayString(_unref(t)('login.welcomeSubtitle')), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("h2", null, _toDisplayString(_unref(t)('login.catchphrase')), 1),
            _createElementVNode("p", null, _toDisplayString(_unref(t)('login.description')), 1),
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: _unref(SharedService).getIcon('frame', false, 'login'),
                class: "frame",
                width: "10%"
              }, null, 8, _hoisted_27),
              _createElementVNode("img", {
                src: _unref(SharedService).getIcon('logos', false, 'login'),
                width: "10%"
              }, null, 8, _hoisted_28)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})